<template>
  <div class="login-wrapper">
    <div class="login-card">
      <div class="logo-container">
        <img src="../../public/logo.png" alt="Publibou Logo" class="logo" />
      </div>

      <div class="welcome-text">
        <h2>Connexion à votre compte</h2>
        <p>Bienvenue sur Publibou - Gérez vos catalogues</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="identifier" class="form-label">Email ou Nom d'utilisateur</label>
          <div class="input-container">
            <i class="fas fa-user input-icon"></i>
            <input
              type="text"
              id="identifier"
              v-model="identifier"
              placeholder="Entrez votre email ou nom d'utilisateur"
              required
              class="form-input"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Mot de passe</label>
          <div class="input-container">
            <i class="fas fa-lock input-icon"></i>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="Entrez votre mot de passe"
              required
              class="form-input"
            />
          </div>
        </div>

        <button type="submit" class="login-btn" :disabled="loading">
          <span v-if="loading" class="spinner"></span>
          <span v-else>Se connecter</span>
        </button>
      </form>

      <div v-if="error" class="error-message">
        <i class="fas fa-exclamation-circle"></i>
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import strapiApi from '../services/strapiApi';
import { userStore } from '@/store/userStore';

export default {
  name: 'LoginView',
  beforeMount() {
    document.querySelector('nav').style.display = 'none';
  },
  beforeUnmount() {
    document.querySelector('nav').style.display = 'block';
  },
  data() {
    return {
      identifier: '',
      password: '',
      error: null,
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.error = null;
      this.loading = true;
      try {
        const response = await strapiApi.login(this.identifier, this.password);
        userStore.login(response.data.user, response.data.jwt);
        this.$router.push('/'); // Redirect to home on success
      } catch (err) {
        this.error = err.response?.data?.error?.message || 'Une erreur est survenue lors de la connexion.';
        console.error('Login error:', err.response?.data || err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Import Font Awesome if not already included globally */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-gradient);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  pointer-events: none;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 1;
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 200px;
  height: auto;
  margin-bottom: 15px;
  object-fit: cover;
}

.baseline {
  font-size: 1.2rem;
  color: #666;
  margin: 10px 0 0 0;
  text-align: center;
  font-style: italic;
}

.brand-name {
  font-size: 28px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.welcome-text {
  text-align: center;
  margin-bottom: 35px;
}

.welcome-text h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 8px 0;
}

.welcome-text p {
  color: #718096;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.login-form {
  margin-bottom: 25px;
}

.form-group {
  margin-bottom: 25px;
}

.form-label {
  display: block;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
  font-size: 14px;
}

.input-container {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 16px;
  z-index: 2;
}

.form-input {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-sizing: border-box;
  outline: none;
}

.form-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: #ffffff;
}

.form-input::placeholder {
  color: #a0aec0;
  font-size: 14px;
}

.login-btn {
  width: 100%;
  padding: 15px;
  background: var(--background-gradient);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  outline: none;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(59, 67, 202, 0.3);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  border: 1px solid #feb2b2;
}

.error-message i {
  margin-right: 8px;
  font-size: 16px;
}

/* Responsive design */
@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
    margin: 20px;
  }

  .brand-name {
    font-size: 24px;
  }

  .welcome-text h2 {
    font-size: 20px;
  }

  .form-input {
    padding: 12px 12px 12px 40px;
    font-size: 14px;
  }

  .input-icon {
    left: 12px;
    font-size: 14px;
  }
}
</style>
